




































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputCode from "@/components/common/input/InputCode.vue";
import requestService from "@/service/requestService";
import { ElButton } from "element-ui/types/button";
import { Getter, Action } from "vuex-class";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import ReservationDetailState from "@/store/reservation/state";
import * as util from "@/service/util";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import InspectValueDialog from "@/components/InspectValueDialog.vue";
import { MD5Inspect } from "@/model/MD5Inspect";
import { InspectDescriptions } from "@/model/InspectGensha";
import { InspectValueItem } from "@/model/InspectItem";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { inspectService } from "@/service/inspectService";
import { CarSelectData } from "@/model/CarSelection";
import { InspectLineResult } from "@/model/InspectLineResult";
import { INSPECT_VALUE_VIEW_TYPE } from "@/model/InspectValueViewType";
import { InspectButtonValue } from "@/model/InspectButtonValue";

@Component({
  components: {
    InputNumber,
    InputCode,
    SaveDialog,
    ConfirmDialog,
    WorkAndBuhin,
    InspectValueDialog
  }
})
export default class inspectLine extends Vue {
  $refs!: {
    btnRigister: ElButton;
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    cancelDialog: ConfirmDialog;
  };
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationState: ReservationDetailState;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;
  @Action("setState", { namespace: "CarSelection" })
  setStateCarSelection: any;

  @Action("setState", { namespace: "InspectLine" })
  setState: any;
  @Action("setSideSlip", { namespace: "InspectLine" })
  setSideSlip: any;

  @Getter("inspectLineList", { namespace: "InspectLine" })
  inspectLineListState: any;

  reqService: requestService;
  service: inspectService;
  errorMsg: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = true;

  headLightKbns: any = [];
  headLightLRKbns: any = [];
  headLightLuminanceKbns: any = [];
  activeInspect: any = {};
  displayValDialog: boolean = false;
  inspectData: InspectDescriptions[] = [];
  speedInspect: InspectDescriptions = {} as InspectDescriptions;
  dieselInspect: InspectDescriptions = {} as InspectDescriptions;
  hasDiesel: boolean = false;
  inspectLineList: InspectLineResult[] = [];
  hasData: boolean = false;
  headLightLuminance: number = 0;
  lightRightLuminance: number = 0;
  isSaving: boolean = false;
  tempSave: any = [];
  isWaitSaveSeibi: boolean = false;

  get uketsuke() {
    if (this.reservationState) {
      return this.reservationState.uketsuke;
    }
    return {};
  }

  get makerCd() {
    if (this.uketsuke.srMakerCd) {
      return this.uketsuke.srMakerCd;
    }
    return "";
  }

  get modelCd() {
    if (this.uketsuke.srModelCd) {
      return this.uketsuke.srModelCd;
    }
    return "";
  }

  created() {
    this.$emit("onactivepage", this.$route.name);
    this.service = new inspectService();
    this.reqService = new requestService();
    this.init();
  }

  init() {
    this.reqService
      .getInspectLineResult(this.uketsukeExtendsId)
      .then(
        data => {
          this.loading = false;
          if (data) {
            this.hasData = true;
            this.inspectLineList = data as InspectLineResult[];
            this.inspectLineList = this.inspectLineList.sort(
              (a: any, b: any) => (a.inspectLineCd > b.inspectLineCd ? 1 : -1)
            );
            console.log(this.inspectLineList);
            if (this.inspectLineList[8].inspectResult == 2) {
              if (this.inspectLineList[8].isMigaki == 1) {
                this.headLightLuminance = 2;
              } else {
                this.headLightLuminance = 3;
              }
            } else {
            this.headLightLuminance = this.inspectLineList[8].inspectResult;
            }
            if (this.inspectLineList[9].inspectResult == 2) {
              if (this.inspectLineList[9].isMigaki == 1) {
                this.lightRightLuminance = 2;
              } else {
                this.lightRightLuminance = 3;
              }
            } else {
            this.lightRightLuminance = this.inspectLineList[9].inspectResult;
            }
            const arrInspected = this.inspectLineList.filter(
              e => e.inspectResult !== 0
            );

            if (
              arrInspected.length > 0 &&
              arrInspected.length < this.inspectLineListState.length
            ) {
              // maybe lost sync here
              this.inspectLineListState.forEach(
                (item: InspectLineResult, index: number) => {
                  if (
                    JSON.stringify(item) !=
                    JSON.stringify(this.inspectLineList[index])
                  ) {
                    this.inspectLineList[index] = item;
                    this.save(item);
                  }
                }
              );
            } else {
              this.setState(this.inspectLineList);
            }
          }
        },
        (error: any) => {
          console.log(error);
          this.onError(error);
          // this.inspectForm.sknUketsukeExtendsId = this.uketsukeExtendsId;
        }
      )
      .catch(error => {
        console.log(error);
        // this.inspectForm.sknUketsukeExtendsId = this.uketsukeExtendsId;
      });
    this.setBtnValue();
    this.reqService
      .getInspectLineSeibi(this.uketsukeExtendsId)
      .then((data: any) => {
        this.setInspectData(data);
      });

    if (this.carSelection.uketsukeCd) {
      this.checkDiesel();
    } else {
      this.reqService
        .getCarSelection(this.uketsukeExtendsId)
        .then((res: any) => {
          res.sknUketsukeExtendsId = this.uketsukeExtendsId;
          this.setStateCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
          this.checkDiesel();
        });
    }
  }

  setInspectData(data: any) {
    if (data) {
      this.inspectData = data;
      if (
        data.inspectLine.length > 0 &&
        data.inspectLine[0].subItems.length > 0
      ) {
        data.inspectLine[0].subItems.forEach((subItem: any) => {
          if (subItem.inspectDescriptions.length > 0) {
            let speedInspect = subItem.inspectDescriptions.find(
              (item: any) => item.inspectCd == MD5Inspect.SpeedMeter
            );
            if (speedInspect) {
              this.$set(this, "speedInspect", speedInspect);
            }
            let dieselInspect = subItem.inspectDescriptions.find(
              (item: any) => item.inspectCd == MD5Inspect.Diesel
            );
            if (dieselInspect) {
              this.$set(this, "dieselInspect", dieselInspect);
            }
          }
        });
      }
    }
  }

  checkDiesel() {
    let hasDiesel = false;
    if (this.carSelection.fuelKbn == 2) {
      hasDiesel = true;
    }
    this.$set(this, "hasDiesel", hasDiesel);
  }

  setBtnValue() {
    this.reqService
      .getKbnSkns("skn_inspect_line_head_light")
      .then(
        data => {
          this.headLightKbns = data;
        },
        (error: any) => {
          console.log(error);
        }
      )
      .catch(error => {
        console.log(error);
      });

    this.reqService
      .getKbnSkns("skn_inspect_line_head_light_koudo")
      .then(
        data => {
          this.headLightLuminanceKbns = data;
        },
        (error: any) => {
          console.log(error);
        }
      )
      .catch(error => {
        console.log(error);
      });

    this.reqService
      .getKbnSkns("skn_inspect_line_head_light_result")
      .then(
        data => {
          this.headLightLRKbns = data;
        },
        (error: any) => {
          console.log(error);
        }
      )
      .catch(error => {
        console.log(error);
      });
  }

  // setForm(props: string, valueProp?: string) {
  //   let value = this.inspectForm[props] == 1 ? 0 : 1;
  //   this.$set(this.inspectForm, props, value);
  //   if (valueProp && value == 1) {
  //     this.$set(this.inspectForm, valueProp, null);
  //   }
  // }

  save(item: InspectLineResult) {
    if (this.isSaving) {
      this.tempSave.push(util.deepCopy(item));
    } else {
      this.isSaving = true;
      this.reqService.saveInspectLineResult(item).then(
        (res: any) => {
          this.setState(this.inspectLineList);
          this.isSaving = false;
          if (res && item.inspectResult == InspectButtonValue.CROSS) {
            setTimeout(() => {
              this.$emit("getnav");
            }, 500);
          }
          this.saveTempSaving();
        },
        error => {
          this.handleError(error);
        }
      );
    }
  }

  saveTempSaving() {
    if (this.tempSave.length > 0) {
      const obj = this.tempSave.pop();
      this.save(obj);
    }
    if (this.isWaitSaveSeibi) {
      this.isWaitSaveSeibi = false;
      this.saveSeibi();
    }
  }

  saveSeibi() {
    if (this.isSaving) {
      this.isWaitSaveSeibi = true;
    } else {
      if (this.inspectLineList[4].inspectResult) {
        this.speedInspect.inspectResult = this.inspectLineList[4].inspectResult;
        this.setWorkBuhinSelected(this.speedInspect);
      }
      if (this.inspectLineList[11].inspectResult) {
        this.dieselInspect.inspectResult = this.inspectLineList[11].inspectResult;
        this.setWorkBuhinSelected(this.dieselInspect);
      }
      this.isSaving = true;
      this.reqService.saveInspectLineSeibi(this.inspectData).then(
        (res: any) => {
          this.isSaving = false;
          this.saveTempSaving();
          if (res.status == 200 && res.body && res.body) {
            this.setInspectData(res.body);
          }
        },
        error => {
          this.handleError(error);
        }
      );
    }
  }

  saveResultAndSeibi(item: InspectLineResult) {
    this.save(item);
    this.saveSeibi();
  }

  setWorkBuhinSelected(inspect: InspectDescriptions) {
    if (inspect.inspectResult == InspectButtonValue.CIRCLE) {
      inspect.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
    } else {
      const findSeibiSelected = inspect.seibiList.find(
        seibi => seibi.buhinSelected > 0
      );
      if (findSeibiSelected) {
        inspect.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      } else {
        inspect.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
      }
    }
  }

  onError(res: any) {
    this.loading = false;
    this.errorMsg = util.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  onSave() {
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
  }

  onRegister() {
    this.$emit("saveSpentTime");
    this.$emit("onregister", { pageName: this.$route.name });
  }

  // Validation
  get isRequired() {
    try {
      if (!this.hasSideSlip) {
        return true;
      }
      if (!this.hasSpeedMeter) {
        return true;
      }
      for (let i = 1; i < 11; i++) {
        if (!this.hasResult(this.inspectLineList[i])) {
          return true;
        }
      }
      if (this.hasDiesel && !this.hasDieselResult) {
        return true;
      }
    } catch (ex) {
      console.log(ex);
    }

    return false;
  }

  get hasSideSlip() {
    const item = this.inspectLineList[0];
    if (item) {
      if (item.inOut && item.inspectResult) {
        return true;
      }
    }
    return false;
  }

  get hasSpeedMeter() {
    if (
      this.hasSpeedValue() &&
      this.hasResult(this.inspectLineList[4]) &&
      this.speedInspect.workBuhinSelected > 0
    ) {
      return true;
    }
    return false;
  }

  hasResult(item: InspectLineResult) {
    return item.inspectResult > 0;
  }

  onEnterlightRightLuminance(e: any) {
    setTimeout(() => {
      if (e.target) {
        e.target.blur();
      }
    }, 100);
  }

  showWork(inspectType: string) {
    let inspect: any = {};
    if (inspectType == "SpeedMeter") {
      inspect = this.speedInspect;
    } else {
      inspect = this.dieselInspect;
    }
    if (inspect) {
      this.activeInspect = {
        ...inspect,
        showWork: true
      };
      this.activeInspect.showWork = true;
    }
  }

  onConfirmBuhin(data: { inspectItem: any; seibi: any; notManual: boolean }) {
    let inspect: any = {};
    if (this.activeInspect.inspectCd == MD5Inspect.Diesel) {
      inspect = this.dieselInspect;
    } else {
      inspect = this.speedInspect;
    }
    this.$set(inspect, "workBuhinSelected", STATUS_SELECT_WORK_BUHIN.Done);
    this.saveSeibi();
  }

  onCloseBuhin() {
    this.$set(this, "activeInspect", {});
  }

  openValueDialog() {
    this.activeInspect = util.deepCopy(this.speedInspect);
    this.activeInspect.showValue = true;
  }

  onConfirmValue(inspectValueList: InspectValueItem[]) {
    if (inspectValueList && inspectValueList.length > 0) {
      this.speedInspect.inspectValueList = inspectValueList;
      let speedMeter = this.service.getInspectResultByInspectValue(
        this.speedInspect.inspectValueViewType,
        inspectValueList
      );
      this.inspectLineList[4].inspectValue = inspectValueList[0].inspectValue;
      this.inspectLineList[4].inspectResult = speedMeter;
      this.speedInspect.inspectResult = speedMeter;
    }
    this.saveResultAndSeibi(this.inspectLineList[4]);
  }

  onCloseValue() {
    this.activeInspect.showValue = false;
    this.activeInspect = {};
  }

  hasSpeedValue() {
    return (
      this.speedInspect.inspectValueList != null &&
      this.speedInspect.inspectValueList.length > 0
    );
  }

  buttonLabel(inspect: InspectDescriptions) {
    if (inspect.workBuhinSelected != null && inspect.workBuhinSelected > 0) {
      return "部品選択済";
    }
    return "部品選択";
  }

  onSideSlipChange(val: number | null) {
    if (val == null) {
      val = 0;
    }
    const result = this.service.getInspectResultByInspectValue(
      INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP,
      [{ inspectValue: val }]
    );
    this.inspectLineList[0].inspectResult = result;
    this.inspectLineList[0].inspectValue = val;
    this.setSideSlip(val);
    this.save(this.inspectLineList[0]);
  }

  onSetChousei(val: number, item: InspectLineResult) {
    if (val == 2) {
      item.isChousei = 1;
    } else {
      item.isChousei = 0;
    }
    this.save(item);
  }

  onChangeKbn(val: number, item: InspectLineResult) {
    if (val == 1) {
      item.inspectResult = 1;
      item.isMigaki = 0;
      item.isKoukan = 0;
    } else {
      item.inspectResult = 2;
      if (val == 2) {
        item.isMigaki = 1;
        item.isKoukan = 0;
      } else {
        item.isMigaki = 0;
        item.isKoukan = 1;
      }
    }
    this.save(item);
  }

  get hasDieselResult() {
    if (
      this.inspectLineList[11].inspectResult > 0 &&
      this.dieselInspect.workBuhinSelected > 0
    ) {
      return true;
    }
    return false;
  }

  handleError(error: any) {
    this.isSaving = false;
    let errorMsg = util.getHttpErrorMessage(error);
    this.$message({
      message: errorMsg,
      type: "error"
    });
    this.init();
  }

  beforeDestroy() {
    this.saveTempSaving();
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      this.$router.push({ name: "reservation" });
    });
  }
}
